import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Form } from "../../../base/views/useForm";

const useStyles = makeStyles((theme) => ({
  Appcss: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    borderRadius: "15px",
    padding: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(1, 0, 1),
  },
}));

const initialFValues = {
  upc: "",
  ndc: "",
  strength: "",
  description: "",
  packsize: "",
  manufacturename: "",
  nonreturnable: "",
  formula: "",
  dcqty: "",
};

export default function AddManualOtcProductForm(props) {
  const classes = useStyles();

  const [addOtcManualProductData, setState] = useState(initialFValues);
  const [errors, setErrors] = React.useState({});

  const {
    addOrEdit,
    recordForEdit,
    addOtcManualProduct,
    captureGoodsState,
  } = props;

  const validate = (fieldValues = addOtcManualProductData) => {
    let temp = { ...errors };

    if ("description" in fieldValues) {
      temp.description =
        fieldValues.description === "" ? "Description is required" : "";
    }

    if ("ndc" in fieldValues) {
      temp.ndc =
        fieldValues.ndc.length < 11
          ? "Invalid NDC min. 11 characters required"
          : fieldValues.ndc.length > 15
          ? "NDC Maximum length exceeded"
          : "";
    }

    if ("packsize" in fieldValues) {
      temp.packsize =
        fieldValues.packsize === "" ? "Pack Size is required" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addOtcManualProduct({
        ...addOtcManualProductData,
        captureGoodsState: captureGoodsState,
      });
      addOrEdit(resetForm);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...addOtcManualProductData,
      [name]: value,
    });
  };

  const resetForm = () => {
    setState(initialFValues);
    setErrors({});
  };

  useEffect(() => {
    if (recordForEdit != null)
      setState({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <Container component="main" maxWidth="sm">
        <div className={classes.form}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                autoFocus
                value={addOtcManualProductData.upc}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="upc"
                label="Upc"
                name="upc"
                autoComplete="upc"
                {...(errors.upc && {
                  error: true,
                  helperText: errors.upc,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={
                  addOtcManualProductData.ndc ||
                  addOtcManualProductData.ndc !== ""
                    ? addOtcManualProductData.ndc
                    : addOtcManualProductData.upc
                }
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="ndc"
                label="NDC"
                name="ndc"
                autoComplete="ndc"
                {...(errors.ndc && {
                  error: true,
                  helperText: errors.ndc,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcManualProductData.strength}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="strength"
                label="Strength"
                name="strength"
                autoComplete="strength"
                {...(errors.strength && {
                  error: true,
                  helperText: errors.strength,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcManualProductData.description}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="description"
                label="Description"
                name="description"
                autoComplete="description"
                {...(errors.description && {
                  error: true,
                  helperText: errors.description,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcManualProductData.packsize}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="packsize"
                label="PackSize"
                name="packsize"
                autoComplete="packsize"
                InputProps={{ inputProps: { min: 1 } }}
                {...(errors.packsize && {
                  error: true,
                  helperText: errors.packsize,
                })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcManualProductData.manufacturename}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="manufacturename"
                label="Manufacture Name"
                name="manufacturename"
                autoComplete="manufacturename"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcManualProductData.nonreturnable}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="nonreturnable"
                label="Non Returnable"
                name="nonreturnable"
                autoComplete="nonreturnable"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                value={addOtcManualProductData.formula}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                id="formula"
                label="Form"
                name="formula"
                autoComplete="formula"
              />
            </Grid>
            <Grid item xs={12}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  style={{
                    width: "20vw",
                    backgroundColor: "rgb(22, 177, 255)",
                    borderRadius: "0.5rem",
                  }}
                  type="submit"
                >
                  Save
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
    </Form>
  );
}
